export default {
  mounted: function mounted() {
    if (this.spec && this.spec.dataset) {
      var data = this.spec.dataset;

      for (var key in this.spec.dataset) {
        this.$el.dataset[key] = data[key];
      }
    }
  }
};